import { Bold } from '../../components/UI/TextFormatters';
import { darken, fade, makeStyles, Typography, IconButton, Tooltip, CircularProgress, lighten } from '@material-ui/core';
import { Pie } from 'react-chartjs-2';
import useClaimStatsPresenter from './ClaimStatsPresenter';
import clsx from 'clsx';
import { Fade } from '@material-ui/core';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import LimitedBackdrop from '../../components/UI/LimitedBackdrop';
import CancelIcon from '@material-ui/icons/Cancel';
import React, { useContext, useEffect, useState } from 'react';
import SwipeTransition from '../../components/UI/SwipeTransition';
import { LoginContext } from '../../contexts/LoginContext';
import { Button } from '@material-ui/core';
import CustomDatePicker from '../../components/UI/CustomDatePicker';
import { commonFilter } from '../../constants/StyleConstants';
import SelectionSwitch from '../../components/UI/SelectionSwitch';
import { InventoriesContext } from '../../contexts/InventoriesContext';

const useStyles = makeStyles(theme => ({
  ...commonFilter,
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  claimDashboard: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    columnGap: '1em',
    width: 'calc(100vw - 150px)',
  },
  cardsSelection: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    flexDirection: 'column',
    maxWidth: '60%',
  },
  selectedCards: {
    position: 'relative',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    margin: '1em',
  },
  summaryCardWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: '.2s ease-in-out',
    borderRadius: '.5em',
    boxShadow:
      'rgba(0, 0, 0, 0.07) 0px 1px 2px, rgba(0, 0, 0, 0.07) 0px 2px 4px, rgba(0, 0, 0, 0.07) 0px 4px 8px, rgba(0, 0, 0, 0.07) 0px 8px 16px, rgba(0, 0, 0, 0.07) 0px 16px 32px, rgba(0, 0, 0, 0.07) 0px 32px 64px',
    backgroundColor: darken(theme.palette.primary.light, 0.3),
  },
  summaryCardWrapperActive: {
    color: 'white',
    backgroundColor: fade(theme.palette.primary.main, 0.8),
  },
  summaryCard: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    rowGap: '.5em',
    columnGap: '1em',
    padding: '1em',
    width: '100%',
  },
  cardWrapper: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '25em',
    margin: '1em',
    transition: '.2s ease-in-out',
    borderRadius: '.5em',
    boxShadow:
      'rgba(0, 0, 0, 0.07) 0px 1px 2px, rgba(0, 0, 0, 0.07) 0px 2px 4px, rgba(0, 0, 0, 0.07) 0px 4px 8px, rgba(0, 0, 0, 0.07) 0px 8px 16px, rgba(0, 0, 0, 0.07) 0px 16px 32px, rgba(0, 0, 0, 0.07) 0px 32px 64px',
    backgroundColor: fade(theme.palette.primary.main, 0.5),
    '&:hover': {
      boxShadow:
        'rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px',
      transform: 'scale(1.05)',
    },
  },
  card: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    columnGap: '1em',
    padding: '1em',
    width: '100%',
  },
  totalClaims: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    backgroundColor: 'rgba(255,255,255,.7)',
    borderRadius: '2em',
    padding: '.2em .5em .2em .5em',
  },
  totalClaimsActive: {
    color: theme.palette.primary.main,
  },
  chartWrapper: {
    borderRadius: '1em',
    overflow: 'hidden',
    position: 'relative',
    width: '35%',
  },
  childrenCardWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    margin: '1em',
    borderRadius: '.5em',
    overflow: 'hidden',
    boxShadow:
      'rgba(0, 0, 0, 0.07) 0px 1px 2px, rgba(0, 0, 0, 0.07) 0px 2px 4px, rgba(0, 0, 0, 0.07) 0px 4px 8px, rgba(0, 0, 0, 0.07) 0px 8px 16px, rgba(0, 0, 0, 0.07) 0px 16px 32px, rgba(0, 0, 0, 0.07) 0px 32px 64px',
  },
  detailsCardWrapper: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    margin: '1em',
    borderRadius: '.5em',
    overflow: 'hidden',
    boxShadow:
      'rgba(0, 0, 0, 0.07) 0px 1px 2px, rgba(0, 0, 0, 0.07) 0px 2px 4px, rgba(0, 0, 0, 0.07) 0px 4px 8px, rgba(0, 0, 0, 0.07) 0px 8px 16px, rgba(0, 0, 0, 0.07) 0px 16px 32px, rgba(0, 0, 0, 0.07) 0px 32px 64px',
  },
  detailsCard: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    rowGap: '.5em',
    padding: '1em',
    width: '100%',
  },
  claimsSummary: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    rowGap: '1em',
  },
  claimType: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: '100%',
    columnGap: '.5em',
  },
  claimsCounter: {
    width: '1.5em',
    height: '1.5em',
    boxSizing: 'initial',
    background: theme.palette.primary.main,
    // border: '0.1em solid black',
    color: 'white',
    textAlign: 'center',
    borderRadius: '50%',
    lineHeight: '1.5em',
    boxSizing: 'content-box',
  },
  loadingMessage: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    rowGap: '1em',
    width: '90vw',
    height: '70vh',
  },
}));

const ClaimChart = React.memo(({ chartColors, chartData, loading, animateChart }) => {
  const classes = useStyles();
  const { getTheClaimTypes } = useContext(InventoriesContext);
  const [chartInfo, setChartInfo] = useState([]);

  useEffect(() => {
    getTheClaimTypes().then(claimTypes => {
      setChartInfo(chartData.map(data => ({ ...data, description: claimTypes.find(ct => ct.id === data.claimType).name })));
    });
  }, [chartData]);

  return (
    <div className={classes.chartWrapper}>
      <LimitedBackdrop open={loading}>
        <CircularProgress color="primary" />
      </LimitedBackdrop>
      <Pie
        options={{
          animation: { duration: !animateChart || loading ? 0 : undefined },
          plugins: {
            legend: {
              onClick: null,
            },
          },
        }}
        data={{
          labels: chartInfo.map(g => g.description),
          datasets: [
            {
              data: chartData.map(g => g.total),
              backgroundColor: chartColors.map(color => lighten(color, 0.3)),
              hoverBackgroundColor: chartColors,
            },
          ],
        }}
      />
    </div>
  );
});

const ClaimChildren = ({ setShowChildren, group, handleSelection }) => {
  const classes = useStyles();

  return (
    <div className={classes.childrenCardWrapper}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', paddingLeft: '1em' }}>
        <div>
          <Bold>Seleccione una opción</Bold>
        </div>
        <IconButton color="secondary" onClick={() => setShowChildren(false)}>
          <CancelIcon />
        </IconButton>
      </div>
      {group.groupChildren.map((g, index) => (
        <div className={classes.cardWrapper} onClick={() => handleSelection(g, group.childrenGroupType)}>
          <div className={classes.card}>
            <Bold>{g.description}</Bold>
            <div className={classes.totalClaims}>
              <Typography variant="h5">{g.total}</Typography>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

const SelectedGroups = ({ selectedGroups, setShowChildren, hasChildren, removeLastGroup, loading }) => {
  const classes = useStyles();

  return (
    <div className={classes.selectedCards}>
      <LimitedBackdrop open={loading}>
        <CircularProgress color="primary" />
      </LimitedBackdrop>
      {selectedGroups.slice(0, -1).map((sel, i) => (
        <div key={i} className={classes.summaryCardWrapper}>
          <div className={classes.summaryCard}>
            <Bold>{sel.description}</Bold>
            <div className={classes.totalClaims}>
              <Typography variant="h5">
                <Bold>{sel.total}</Bold>
              </Typography>
            </div>
          </div>
        </div>
      ))}
      <div className={clsx(classes.summaryCardWrapper, classes.summaryCardWrapperActive)}>
        <div className={classes.summaryCard}>
          <Bold>{selectedGroups.last()?.description}</Bold>
          <div className={clsx(classes.totalClaims, classes.totalClaimsActive)}>
            <Typography variant="h5">
              <Bold>{selectedGroups.last()?.total}</Bold>
            </Typography>
          </div>
        </div>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', marginLeft: '.5em' }}>
        <Tooltip title="Agregar desglose">
          <span>
            <IconButton disabled={!hasChildren || loading} style={{ padding: 0 }} color="secondary" onClick={() => setShowChildren(true)}>
              <AddCircleIcon fontSize="large" />
            </IconButton>
          </span>
        </Tooltip>
        <Tooltip title="Quitar último desglose">
          <span>
            <IconButton disabled={selectedGroups.length == 1 || loading} style={{ padding: 0 }} color="secondary" onClick={removeLastGroup}>
              <RemoveCircleIcon fontSize="large" />
            </IconButton>
          </span>
        </Tooltip>
      </div>
    </div>
  );
};

const ClaimSummaryDetails = ({ chartData, loading }) => {
  const classes = useStyles();
  const { getTheClaimTypes } = useContext(InventoriesContext);
  const [chartInfo, setChartInfo] = useState([]);

  useEffect(() => {
    getTheClaimTypes().then(claimTypes => {
      setChartInfo(chartData.map(data => ({ ...data, description: claimTypes.find(ct => ct.id === data.claimType).name })));
    });
  }, [chartData]);

  return (
    <div className={classes.detailsCardWrapper}>
      <LimitedBackdrop open={loading}>
        <CircularProgress color="primary" />
      </LimitedBackdrop>
      <div className={classes.detailsCard}>
        <Bold>Detalle</Bold>
        <div className={classes.claimsSummary}>
          {chartInfo.map(c => (
            <div className={classes.claimType}>
              <div className={classes.claimsCounter}>{c.total}</div>
              <div>{c.description}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const Filters = ({ filterByDate, setFilterByDate, dateFrom, setDateFrom, dateTo, setDateTo, validateAndSearch, cleanFilters }) => {
  const classes = useStyles();

  return (
    <div className={classes.filters}>
      <SelectionSwitch leftLabel="Pendientes a hoy" rightLabel="Por fecha" value={filterByDate} setValue={setFilterByDate} />
      <CustomDatePicker
        disableMinDate
        disabled={!filterByDate}
        value={dateFrom}
        maxDate={dateTo}
        label="Fecha desde"
        setValue={setDateFrom}
      />
      <CustomDatePicker
        disableMinDate
        disabled={!filterByDate}
        value={dateTo}
        minDate={dateFrom || undefined}
        label="Fecha hasta"
        setValue={setDateTo}
      />
      <div className={classes.filtersActionButton}>
        <Button variant="outlined" color="primary" onClick={validateAndSearch}>
          Filtrar
        </Button>
        <Button variant="outlined" color="secondary" onClick={cleanFilters}>
          Limpiar
        </Button>
      </div>
    </div>
  );
};

const ClaimStats = () => {
  const classes = useStyles();
  const { showBreakdown, filterProps, selectedGroupsProps, childSelectionProps, detailsProps, chartProps, showChildren } =
    useClaimStatsPresenter();

  return selectedGroupsProps.selectedGroups.isEmpty() ? (
    <div className={classes.loadingMessage}>
      <div>Cargando datos, aguarde por favor...</div>
      <CircularProgress color="primary" />
    </div>
  ) : (
    <Fade in>
      <div className={classes.root}>
        <Filters {...filterProps} />
        <div className={classes.claimDashboard}>
          <div className={classes.cardsSelection}>
            {showBreakdown && <SelectedGroups {...selectedGroupsProps} />}

            {selectedGroupsProps.selectedGroups[0].total != 0 && (
              <SwipeTransition transitionKey={showChildren}>
                {!showChildren ? <ClaimSummaryDetails {...detailsProps} /> : <ClaimChildren {...childSelectionProps} />}
              </SwipeTransition>
            )}
          </div>
          <ClaimChart {...chartProps} />
        </div>
      </div>
    </Fade>
  );
};

export default ClaimStats;
